import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
const paths = ["/", "/apply", "/current-openings/details", "/success"];
const NotFound = (props) => {
    const history = useHistory();
    useEffect(() => {
        if(paths.indexOf(props.location.pathname) === -1) {
            history.push("/");
        } 
    }, [props])
    return null;
}

export default NotFound;